import axios from 'axios';
import useHasAccessToPage from 'hooks/useHasAccessToPage';
import usePermissions from 'hooks/usePermissions';
import { useSaveDataFromUrl } from 'hooks/useSaveDataFromUrl';
import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { GeneralIds, RoutePaths } from 'types/types';
import { getRoutePath } from 'utils';

interface ProtectedRouteProps {
  children: JSX.Element;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  // TODO: refactor these
  useSaveDataFromUrl();
  usePermissions();
  const navigate = useNavigate();
  const { hasAccess } = useHasAccessToPage();
  const { projectId } = useParams<GeneralIds>();

  useEffect(() => {
    if (!hasAccess) {
      navigate(getRoutePath(RoutePaths.projectDashboard, { projectId }));
    }
  }, [hasAccess, navigate, projectId]);

  const token = localStorage.getItem('token');
  if (token) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  } else {
    navigate(getRoutePath(RoutePaths.login));
  }

  return children;
}
